import { render, staticRenderFns } from "./ApprovalGrid.vue?vue&type=template&id=1e1760d0&scoped=true"
import script from "./ApprovalGrid.ts?vue&type=script&lang=ts&external"
export * from "./ApprovalGrid.ts?vue&type=script&lang=ts&external"
import style0 from "./ApprovalGrid.vue?vue&type=style&index=0&id=1e1760d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1760d0",
  null
  
)

export default component.exports